import { PropsWithChildren } from 'react';
import { BlockWrapper } from '../BlockWrapper/BlockWrapper';
import { InfinityMarquee } from '@designsystem/stories/04-organisms/InfinityMarquee';

interface Term {
  textline: string;
}

export interface BlockDataProps {
  terms?: Term[];
}

interface ViewProps {
  data: BlockDataProps;
  isEdit?: boolean;
  block?: string;
  onChangeBlock?: (blockId: string, newData: any) => void;
}

const Factory = (props: PropsWithChildren) => <>{props.children}</>;

const View = (props: ViewProps) => {
  const data = { ...props?.data };

  const terms = [] as string[];

  (data?.terms || []).forEach((term) => {
    if (!term || !term?.textline) {
      return;
    }

    terms.push(term.textline.trim());
  });

  if (!props?.isEdit && !terms.length) {
    return null;
  }

  return (
    <>
      <BlockWrapper
        data={{
          block_fullwidth: true,
        }}
        factory={Factory}
      >
        <InfinityMarquee terms={terms} />
      </BlockWrapper>
    </>
  );
};

export default View;
